import { render, staticRenderFns } from "./linkProductsToGroupModal.vue?vue&type=template&id=96455518"
import script from "./linkProductsToGroupModal.vue?vue&type=script&lang=js"
export * from "./linkProductsToGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports